<template>
  <div class="hello">
    <div class="meeting-types-wrapper">
      <p v-if="error" class="form-error">{{ error }}</p>
      <q-select
          class="team-select"
          outlined
          emit-value
          map-options
          v-model="selectedTeamId"
          :options="teamOptions"
          label="Команда"
          @update:model-value="getMeetingTypes"
      />
      <p v-if="teamsLoaded && teamOptions.length === 0" class="form-hint">Нет доступных команд. Создайте команду или попросите доступ у владельца.</p>
      <q-table
          v-if="selectedTeamId"
          title="Типы встреч"
          :rows="meetingTypes"
          :columns="columns"
          :pagination="pagination"
          row-key="id"
          binary-state-sort
      >
        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td key="name" :props="props">
              {{ props.row.name }}
            </q-td>
            <q-td key="rotationDays" :props="props">
              <q-option-group
                  v-model="props.row.rotation_days"
                  :options="weekdayOptions"
                  color="primary"
                  type="checkbox"
                  inline
                  dense
              />
            </q-td>
            <q-td key="rotationIntervalWeeks" :props="props">
              <q-select
                  v-model="props.row.rotation_interval_weeks"
                  :options="intervalOptions"
                  emit-value
                  map-options
                  dense
                  outlined
              />
            </q-td>
            <q-td key="rotationAnchorDate" :props="props">
              <q-input
                  v-model="props.row.rotation_anchor_date"
                  type="date"
                  dense
                  outlined
              />
            </q-td>
            <q-td key="actions" :props="props">
              <q-btn flat round color="primary" @click="saveSchedule(props.row)">
                <font-awesome-icon icon="fa-solid fa-floppy-disk" />
              </q-btn>
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div v-if="selectedTeamId" class="add-meeting-type">
        <q-input outlined v-model="newMeetingType" label="Название встречи" />
        <q-btn @click="addMeetingType" color="primary" label="Добавить новый тип встречи" />
      </div>
    </div>
  </div>
</template>

<script>
import grpc from "@/services/grpc";

export default {
  name: 'MeetingTypes',
  created() {
    this.loadTeams();
  },
  data() {
    const columns = [
      {
        name: 'name',
        required: true,
        label: 'Название встречи',
        align: 'left',
        field: row => row.name,
        format: val => `${val}`,
        sortable: true
      },
      {
        name: 'rotationDays',
        label: 'Дни',
        align: 'left',
        field: 'rotation_days'
      },
      {
        name: 'rotationIntervalWeeks',
        label: 'Период',
        align: 'left',
        field: 'rotation_interval_weeks'
      },
      {
        name: 'rotationAnchorDate',
        label: 'Неделя старта',
        align: 'left',
        field: 'rotation_anchor_date'
      },
      {
        name: 'actions',
        label: '',
        align: 'center',
      },
    ];
    const pagination = {
      sortBy: 'asc',
      descending: false,
      rowsPerPage: 0
    };
    return {
      grpcClient: new grpc(),
      newMeetingType: "",
      teams: [],
      selectedTeamId: null,
      teamsLoaded: false,
      error: "",
      meetingTypes: [],
      meetingTypeOptions: [],
      columns: columns,
      pagination: pagination,
      weekdayOptions: [
        { label: 'Пн', value: 1 },
        { label: 'Вт', value: 2 },
        { label: 'Ср', value: 3 },
        { label: 'Чт', value: 4 },
        { label: 'Пт', value: 5 },
        { label: 'Сб', value: 6 },
        { label: 'Вс', value: 7 },
      ],
      intervalOptions: [
        { label: 'Каждую неделю', value: 1 },
        { label: 'Раз в 2 недели', value: 2 },
      ],
    };
  },
  computed: {
    teamOptions() {
      return this.teams.map(team => ({label: team.name, value: team.id}));
    },
  },
  methods: {
    async loadTeams() {
      this.error = "";
      try {
        const teams = await this.grpcClient.getTeams();
        this.teams = teams.map(team => ({id: team.getId(), name: team.getName()}));
        this.teamsLoaded = true;
        if (this.teams.length > 0) {
          this.selectedTeamId = this.teams[0].id;
          await this.getMeetingTypes();
        }
      } catch (err) {
        this.error = err.message || "Не удалось загрузить команды";
      }
    },
    async addMeetingType() {
      if (!this.newMeetingType || !this.selectedTeamId) {
        return;
      }
      await this.grpcClient.createMeetingType(this.newMeetingType, this.selectedTeamId);
      await this.getMeetingTypes()
      this.newMeetingType = "";
    },
    async getMeetingTypes() {
      if (!this.selectedTeamId) {
        this.meetingTypes = [];
        this.meetingTypeOptions = [];
        return;
      }
      this.meetingTypes = await this.grpcClient.getMeetingTypesSchedule(this.selectedTeamId)
      this.meetingTypeOptions = [];
      for (let meetingType of this.meetingTypes) {
        this.meetingTypeOptions.push({
          label: meetingType.name,
          value: meetingType.id
        });
      }
    },
    async saveSchedule(meetingType) {
      await this.grpcClient.updateMeetingTypeSchedule(meetingType.id, {
        rotation_days: meetingType.rotation_days,
        rotation_interval_weeks: meetingType.rotation_interval_weeks,
        rotation_anchor_date: meetingType.rotation_anchor_date,
      });
      await this.getMeetingTypes();
    },
  },
}
</script>

<style lang="scss" scoped>
.meeting-types-wrapper {
  max-width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.team-select {
  width: min(420px, 100%);
  margin-bottom: 16px;
}
.form-error {
  color: #c10015;
}
.form-hint {
  color: #546179;
}
.add-meeting-type {
  display: inline-block;
  padding: 20px 0;
  .q-field {
    margin-bottom: 20px;
  }
}
</style>
